import React from 'react';
import PropTypes from 'prop-types';
import ActionButton from './ActionButton';
import ArrowBackIosOutlinedIcon from '@material-ui/icons/ArrowBackIosOutlined';
import classes from './buttons.module.css';

function BackButton({ onClick }) {
    return (
        <ActionButton containerClass={classes.back} text={<ArrowBackIosOutlinedIcon />} onClick={onClick} />
    );
}

BackButton.propTypes = {
	onClick: PropTypes.func.isRequired
};

export default BackButton;